module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmEU9fABc4EsA.7fd643e6.woff2";